import React from "react";
import { useTranslation } from "react-i18next";

import WPButton from "../../packages/WPButton";

const ViewPlantCellRenderer = (props) => {
  const { data, context } = props;
  const { t } = useTranslation();

  const handleViewPlant = () => {
    context?.handleViewPlant?.({ data });
  };

  return (
    <WPButton onClick={handleViewPlant}>{t("addNewPlant.viewPlants")}</WPButton>
  );
};

export default ViewPlantCellRenderer;
